export default class GetConvocatoriaPersonalByPersonalIdAndId {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute(idPersonal, idConvocatoriaPersonal) {
    try {
      const result = await this.#repository.getConvocatoriaPersonalByPersonalIdAndId(idPersonal, idConvocatoriaPersonal)
      return result
    } catch (error) {
      console.error('Error al obtener la asignación de convocatoria:', error)
      throw error
    }
  }
}
